// ----------------------------------------------------------------------

export function getCoresTemplate(tipoAtendente: any) {
  if (tipoAtendente === 1) {
    /* CONFIGURAÇÃO ANJO */
    return {
      nomeTipoAtendente: 'Anjo',
      corPrincipal: 'corPrincipalAnjo',
      corSecundaria: 'corSecundariaAnjo',
      capaAtendenteDashFirstDesk: 'CapaAtendenteCoverProfileDesktopAnjo',
      chipListaAtendentes: 'chipTipoAtendenteAnjo',
      chipListaAtendentescolor: 'chipTipoAtendenteAnjoborder',
    };
  }

  if (tipoAtendente === 2) {
    /* CONFIGURAÇÃO PSICOLOGO */
    return {
      nomeTipoAtendente: 'Psicólogo(a)',
      corPrincipal: 'corPrincipalPsicologo',
      corSecundaria: 'corSecundariaPsicologo',
      capaAtendenteDashFirstDesk: 'CapaAtendenteCoverProfileDesktopPsicologo',
      chipListaAtendentes: 'chipTipoAtendentePsicologo',
      chipListaAtendentescolor: 'chipTipoAtendentePsicologoborder',
    };
  }

  if (tipoAtendente === 3) {
    /* CONFIGURAÇÃO PSICANALISTA */
    return {
      nomeTipoAtendente: 'Psicanalista',
      corPrincipal: 'corPrincipalPsicanalista',
      corSecundaria: 'corSecundariaPsicanalista',
      capaAtendenteDashFirstDesk: 'CapaAtendenteDashFirstDeskPsicanalista',
      chipListaAtendentes: 'chipTipoAtendentePsicanalista',
      chipListaAtendentescolor: 'chipTipoAtendentePsicanalistaborder',
    };
  }

  if (tipoAtendente === 4) {
    /* CONFIGURAÇÃO TERAPEUTA */
    return {
      nomeTipoAtendente: 'Terapeuta',
      corPrincipal: 'corPrincipalTerapeuta',
      corSecundaria: 'corSecundariaTerapeuta',
      capaAtendenteDashFirstDesk: 'CapaAtendenteCoverProfileDesktopTerapeuta',
      chipListaAtendentes: 'chipTipoAtendenteTerapeuta',
      chipListaAtendentescolor: 'chipTipoAtendenteTerapeutaborder',
    };
  }

  if (tipoAtendente === 5) {
    /* CONFIGURAÇÃO COACH */
    return {
      nomeTipoAtendente: 'Coach',
      corPrincipal: 'corPrincipalCoach',
      corSecundaria: 'corSecundariaCoach',
      capaAtendenteDashFirstDesk: 'CapaAtendenteCoverProfileDesktopCoach',
      chipListaAtendentes: 'chipTipoAtendenteCoach',
      chipListaAtendentescolor: 'chipTipoAtendenteCoachborder',
    };
  }




  return {
    nomeTipoAtendente: 'Anjo',
    corPrincipal: 'corPrincipalAnjo',
      corSecundaria: 'corSecundariaAnjo',
      capaAtendenteDashFirstDesk: 'CapaAtendenteCoverProfileDesktopAnjo',
      chipListaAtendentes: 'chipTipoAtendenteAnjo',
   };
}
